module.exports = __webpack_public_path__ + "img/p2-38.c95d3a27.png";